import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { TechnologyoverlayService } from '../../technologyoverlay.service';
import { takeUntil } from 'rxjs/operators';
import { SessionCheck, generateAlertMessage, AuthFailedMessage,getFeatureNeedtoShow,LoadTechnologySpaceSvg, map_widthandheight  } from '../../../../app-general';
import { mapTemplate_creation, get_geojsonObject_floor, label_Polygon, fillcolor_style,} from '../../../../map-general';
import {appsettings, DeviceTypeDesc, DeviceType, NewDeviceTypeDesc,enumRequestFrom, fillcolorPolygon,enumUIFeatureView, enumUIAction, enumUIView} from '../../../../app-settings';
import {Router} from '@angular/router';
import { GeneralMessageComponent } from '../../../../general-message/general-message.component';
import { TechnologyForCreationResponse, getTemplateInfo, loadTemplateFloor, loadTemplateDevice, deleteTempSpace, deleteTemplate, deletTemplateDevice, updateTemplate } from '../../technologyoverlay';
import { EditFloordeviceComponent } from '../edit-floordevice/edit-floordevice.component';
import { ConfirmMessageComponent } from '../../../../confirm-message/confirm-message.component';
import { ApiService } from '../../../../api.service';
import { AlertSharedService } from '../../../../_services/index';
import { EditFloorspaceComponent } from '../edit-floorspace/edit-floorspace.component';
import { AlertMessageComponent } from '../../../../alert-message/alert-message.component';

import { Fill, Stroke, Style, Text } from 'ol/style';


@Component({
  selector: 'app-edit-templates',
  templateUrl: './edit-templates.component.html',
  styleUrls: ['./edit-templates.component.scss']
})
export class EditTemplatesComponent implements OnInit {
  bAddEdit:boolean=false;
  bDelete:boolean=false;
  public flooreditTemplateForm : FormGroup;
  selectedTempId;
  FloorInfo;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  SpaceInfo=[];
  watcher: Subscription;
  columns = 3;
  firstcolumns = 2;
  minheight = "350px"; 
  rowHeight = "79px";
  checkfloorinfo = false;
  select_SpaceIds = [];
  Campusdetails;
  Buildingdetails;
  selectedCampusId;
  selectedBuildingId;
  selectTemplateName;
  DeviceInfo=[];
  floorImgUrl;
  TempFloordata=[];
  deletetempdevicedialogopen = 0;
  ZoneTempCount;
  floorImageName = "";
  Zoneimageurl = appsettings.TEMPLATE_IMAGE_FOLDER;  

  selectTemplateId;
  Map_image_path = 'assets/images/';
    
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<EditTemplatesComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService,public dialog: MatDialog,private alertSharedService: AlertSharedService,private apiService: ApiService) { 
    
    this.selectedTempId = data.TemplateId;
    this.TempFloordata = data;
    this.selectTemplateName = data.TemplateName + "-" + data.Description; 
    this.selectTemplateId = "mapEditZone_" + data.TemplateId;   
    this.ZoneTempCount = data.FloorCnt; 
    if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Templates_AddEditDelete) == enumUIView.Show) {
      this.bAddEdit = true;
      this.bDelete = true;
    }  
    setTimeout(() => {
      this.DrawMapCall(this, data);
    }, 1 * 500);
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {
          this.columns = 2;  
          this.firstcolumns = 1;                  
          this.minheight = "auto";
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 2;
          this.firstcolumns = 2;     
          this.minheight = "auto";
        }  
        else if (change.mqAlias == 'md') {
          this.columns = 2;  
          this.firstcolumns = 1; 
          this.minheight = "350px";               
        }               
       else
       {
         this.columns = 4;  
         this.firstcolumns = 2;      
         this.minheight = "350px";               
       }
      }
    
    });
  }

  ngOnInit() {
    this.flooreditTemplateForm = new FormGroup({
      tempname: new FormControl('',[Validators.required,Validators.maxLength(65), Validators.pattern(appsettings.Name_Pattern)]),
      tempID: new FormControl(''),       
    });
    if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Templates_AddEditDelete) == enumUIView.Show) {
      this.bAddEdit = true;
      this.bDelete = true;
    }  
    
    this.loadTemplateForFloor();
    this.loadTemplatesForDevice();
  }
  
loadTemplateForFloor()
{
  try
  {
    let voiceLicense = localStorage.getItem("voice_license");
    let buildbyid : loadTemplateFloor =  
    { 
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      templateId: parseInt(this.selectedTempId),
      isNeedIntercom : parseInt(voiceLicense)
    }
    this.technologyoverlayService.loadTemplateForFloor(buildbyid).pipe(takeUntil(this._onDestroy))
      .subscribe((spaceinfo: any[]) => {
                
          if(spaceinfo.length == 1  && spaceinfo[0].TemplateId == null)
          {
            this.SpaceInfo = [];
          }
          else{
            this.SpaceInfo = spaceinfo; 
          }
          this.floorImgUrl = this.Zoneimageurl  + spaceinfo[0].TempZoneImage;  
          this.floorImageName = spaceinfo[0].TempZoneImage;    

      });
  }
  catch(err)
  {
      throw new Error('edit-templates.component.ts' + ' - loadTemplateForFloor() - ' + err.message);
  }
}  

loadTemplatesForDevice()
{
  try
  {
    let voiceLicense = localStorage.getItem("voice_license");
    let buildbyid : loadTemplateDevice =  
    { 
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      templateId: parseInt(this.selectedTempId), 
      templateCategory : 1,
      isNeedIntercom : parseInt(voiceLicense)
    }
    this.technologyoverlayService.loadTemplatesForDevice(buildbyid).pipe(takeUntil(this._onDestroy))
      .subscribe((deviceinfo: any[]) => {
          
        
        deviceinfo.forEach(function (e) {
                
          if (e.DeviceName == DeviceTypeDesc.Emitter) {
            e['NewDeviceName'] = NewDeviceTypeDesc.Emitter;
            e['DeviceType'] = DeviceType.Emitter;
          }
          else if (e.DeviceName == DeviceTypeDesc.HRex) {
            e['NewDeviceName'] = NewDeviceTypeDesc.HRex;
            e['DeviceType'] = DeviceType.HRex;
          }
          else if (e.DeviceName == DeviceTypeDesc.Rex) {
            e['NewDeviceName'] = NewDeviceTypeDesc.Rex;
            e['DeviceType'] = DeviceType.Rex;
          }
          else if (e.DeviceName == DeviceTypeDesc.LF) {
            if (e.SubType==DeviceType.DripTray)
            {
              e['NewDeviceName'] = NewDeviceTypeDesc.DripTray;
            }
            else
            {
              e['NewDeviceName'] = NewDeviceTypeDesc.LFExiter;
            }
            e['DeviceType'] = DeviceType.LF;
          }
          else if (e.DeviceName == DeviceTypeDesc.Pullcord) {
            e['NewDeviceName'] = NewDeviceTypeDesc.Pullcord;
            e['DeviceType'] = DeviceType.Pullcord;
          }
          else if (e.DeviceName == DeviceTypeDesc.DC || e.DeviceName == DeviceTypeDesc.NewDC) {
            e['NewDeviceName'] = NewDeviceTypeDesc.DC;
            e['DeviceType'] = DeviceType.DC;
          }
          else if (e.DeviceName == DeviceTypeDesc.Monitor) {
            e['NewDeviceName'] = NewDeviceTypeDesc.Monitor;
            e['DeviceType'] = DeviceType.Monitor;
          }
          else if (e.DeviceName == DeviceTypeDesc.VW) {
            e['NewDeviceName'] = NewDeviceTypeDesc.VW;
            e['DeviceType'] = DeviceType.VW;
          }
          else if (e.DeviceName == DeviceTypeDesc.Gateway) {
            e['NewDeviceName'] = NewDeviceTypeDesc.Gateway;
            e['DeviceType'] = DeviceType.Gateway;
          }
          else if (e.DeviceName == DeviceTypeDesc.UT ) { 
            e['NewDeviceName'] =  NewDeviceTypeDesc.UT;
            e['DeviceType'] = DeviceType.UT;
          }
          else if (e.DeviceName == DeviceTypeDesc.UM ) { 
            e['NewDeviceName'] =  NewDeviceTypeDesc.UM;
            e['DeviceType'] = DeviceType.UM;
          }
          else if (e.DeviceName == DeviceTypeDesc.Intercom ) { 
            e['NewDeviceName'] =  NewDeviceTypeDesc.Intercom;
            e['DeviceType'] = DeviceType.IC;
          }
          else {
            e['NewDeviceName'] = NewDeviceTypeDesc.Zone;
            e['DeviceType'] = DeviceType.Zone;
          }
        })
        if(deviceinfo.length == 1  && deviceinfo[0].TemplateId == null)
        {
          this.DeviceInfo = [];
        }
        else{
          this.DeviceInfo = deviceinfo; 
        }
        
      });
    }
    catch(err)
    {
        throw new Error('edit-templates.component.ts' + ' - loadTemplatesForDevice() - ' + err.message);
    }
}

getTemplatesInfo()
{
  try
  {
    let voiceLicense = localStorage.getItem("voice_license");
  let buildbyid : getTemplateInfo =  
  { 
    siteId: this.SiteId,
    authKey: localStorage.getItem("Authkey"),
    templateId: parseInt(this.selectedTempId), 
    templateCategory : 1,
    isNeedIntercom:parseInt(voiceLicense)
     
  }
  this.technologyoverlayService.getTemplatesInfo(buildbyid).pipe(takeUntil(this._onDestroy))
    .subscribe((templatesinfo: any[]) => {      
      var Templates = templatesinfo["Templateinfo"][0]
      this.DrawMapCall(this, Templates);
    });
  }
  catch (err) {
    throw new Error('edit-templates.component.ts' + ' - getTemplatesInfo() - ' + err.message);
  } 
}

deleteSpacedetails(Spacedata)
{
  var Device_Count="";
  var message="";
  if(Spacedata.DeviceCount >= 0)   
  {
    message = "It contains ";
    Device_Count = Spacedata.DeviceCount + " Devices.";
  }
  
    
    var GeneralMessageData = {
      General_header:  "Delete Space ",                
      GeneralMessage:  "Are you sure you would like to delete this Space?<br> " + message + " <b>" + Device_Count + " </b>",
      General_first:  "Yes ",
      General_second:  "No"
    }     
    let dialogRef = this.dialog.open(GeneralMessageComponent, {
      disableClose: true,
      width: 'auto',
      height: '220px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: GeneralMessageData
    });     
    dialogRef.afterClosed().subscribe(result => {     
      if(result == "First")
      {                     
          this.deleteTemplateSpace(Spacedata)         
      }
      else
      {                
        dialogRef.close('Cancel');          
        return;
      }
    });
  
}

deleteTemplateSpace(deletespacedata)
{
  try
  {    
    let deletespace: deleteTempSpace = 
    {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      templateId: parseInt(deletespacedata.TemplateId),
      spaceId: parseInt(deletespacedata.TempUnitId)      
    };    
    this.technologyoverlayService.deleteTemplateSpace(deletespace).pipe(takeUntil(this._onDestroy))
    .subscribe((apiresponse : TechnologyForCreationResponse[])=>
    {       
      if(apiresponse.toString() == "true")
      { 	                             
        generateAlertMessage(this.dialog, 'Space deleted successfully.');      
        this.loadTemplateForFloor();
        this.loadTemplatesForDevice();
      } 
      else if(apiresponse.toString() == "false")
      {                  
        generateAlertMessage(this.dialog, 'Space deleted failed.')
      }
      else if(apiresponse["condition"] == "Authfalse")
      {    
          this.thisDialogRef.close('close');              
          AuthFailedMessage(this.dialog,this.router);  
          return;       
      }          
    })
  }
  catch(err)
  {
      throw new Error('edit-templates.component.ts' + ' - deleteTemplateSpace() - ' + err.message);
  }
   
}

clkdltFloorconfirmdialog(floordata)
{
  
  
  var GeneralMessageData = {
    General_header:  "Delete Template ",                
    GeneralMessage:  "Would you like to delete this template?</b>",
    General_first:  "Yes ",
    General_second:  "No"
  }     
  let dialogRef = this.dialog.open(GeneralMessageComponent, {
    disableClose: true,
    width: 'auto',
    height: '220px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
    data: GeneralMessageData
  });     
  dialogRef.afterClosed().subscribe(result => {     
    if(result == "First")
    {                     
        this.deleteTemplate(floordata)         
    }
    else
    {                
      dialogRef.close('Cancel');          
      return;
    }
  });
}

deleteTemplate(floorData)
{
  try
  {
    let deletetempfloorbyid: deleteTemplate = {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      templateId:parseInt(floorData.TemplateId),
      templateCategoryId: parseInt(floorData.TemplateCategoryId)
    }    
    this.technologyoverlayService.deleteTemplate(deletetempfloorbyid).pipe(takeUntil(this._onDestroy))
    .subscribe((apiresponse : TechnologyForCreationResponse[])=>{         
    if(apiresponse.toString() == "true")
    { 	            
      generateAlertMessage(this.dialog, 'Zone Template deleted successfully.')
    } 
    else if(apiresponse.toString() == "false")
    {                  
      generateAlertMessage(this.dialog, 'Zone Template  deleted failed.')
    }
    else if(apiresponse["condition"] == "Authfalse")
    {    
        this.thisDialogRef.close('close');              
        AuthFailedMessage(this.dialog,this.router);  
        return;       
    }      
    this.thisDialogRef.close("Delete");
   })
  }
  catch(err)
  {
      throw new Error('edit-templates.component.ts' + ' - deleteTemplate() - ' + err.message);
  }
}

editDevicedetails(devicedata)
{
    var width = "37em";
    var height = "585px"
    
    
    if(devicedata.DeviceName == 'UT')
    {
      width = "87rem";
      height = "740px";
    }
    
    let dialogRef = this.dialog.open(EditFloordeviceComponent, {
      disableClose: true,
      width: width,
      height:height,
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: devicedata
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result == "flooreditclose")
        this.loadTemplatesForDevice();
        this.getTemplatesInfo();
    });
}

delete_Devicedetails(Devicedata)
{
  try
  {
    var ConfirmMessageData;
 
    var deviceId_delete;
    if(Devicedata.DeviceName == "Gateway")
      deviceId_delete = Devicedata.MacId;
    else
      deviceId_delete = Devicedata.DeviceInfo;

    ConfirmMessageData = {        
      ConfirmMessage: "Are you sure you want to delete "+ Devicedata.NewDeviceName + "?" 
    }                 
      
     if(this.deletetempdevicedialogopen == 0)
     {
        let dialogRef = this.dialog.open(ConfirmMessageComponent, {
          disableClose: true,
          width: 'auto',
          height: '200px',
          panelClass: 'myapp-no-padding-dialog',
          autoFocus: false,
          data: ConfirmMessageData
        });     
        this.deletetempdevicedialogopen = 1;
        dialogRef.afterClosed().subscribe(result => {     
          this.deletetempdevicedialogopen = 0;
            if(result == "Yes")
            {                                 
              this.deleteTemplateDeviceId(Devicedata);            
            }
            else
            {
                dialogRef.close('Cancel');            
                return;
            }    
          });
      }
   
  }
  catch(err)
  {
      throw new Error('edit-templates.component.ts' + ' - confirmation() - ' + err.message);
  }   
}

deleteTemplateDeviceId(Data)
{
  try
  {                
      var deviceDetails : deletTemplateDevice = 
      {
        siteId:this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        templateId: parseInt(Data.TemplateId),
        dataId:parseInt(Data.DataId),
        deviceType:parseInt(Data.DeviceType)
      }
      this.technologyoverlayService.deleteTemplateDeviceId(deviceDetails).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse: TechnologyForCreationResponse[]) => 
      { 
        var AlertMessage='Device details deleted successfully.';
        var AlertMessageData = {
          AlertMessage: AlertMessage
        }
        var  _height = 'auto';
        if(apiresponse.toString() == "true")
        {
          let alertdialog = this.dialog.open(AlertMessageComponent, {
            disableClose: true,
            width: 'auto',
            height: _height,
            panelClass: 'myapp-no-padding-dialog',
            autoFocus: false,
            data: AlertMessageData
          });
      
          alertdialog.afterClosed().subscribe(result => {    
            if(result == 'Ok')
            {
              this.loadTemplateForFloor();
              this.loadTemplatesForDevice()
            }
          });         
        }
        else if(apiresponse.toString() == "false")
        {
          generateAlertMessage(this.dialog, 'Device details deleted failed.');          
        }
      });                          
         
  }
  catch(err)
  {
      throw new Error('edit-templates.component.ts' + ' - deleteTemplateDeviceId() - ' + err.message);
  }  
}

public onCloseCancel = () => {   
  this.thisDialogRef.close('Cancel');
  if(!SessionCheck(this.router))
  {
      return;
  }
  
}

editfloorSpacedetails(floorspacedata)
{   
  let floorspace_data = JSON.stringify(floorspacedata);
  let dialogRef = this.dialog.open(EditFloorspaceComponent, {
    disableClose: true,
    width: '32em',
    height:'550px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
    data:JSON.parse(floorspace_data),
  });

  dialogRef.afterClosed().subscribe(result => {   
    let floorplanslistelement = document.getElementById('divfloorplandetails');
        floorplanslistelement.className = 'clsenable';       
    if(result != "Cancel")
    {
      this.loadTemplateForFloor();
      this.loadTemplatesForDevice();
    }
  })
}


public updateTemplateInfo = (zonetempFormValue) => 
{

  try
  {
    var TempDescriName;
    var TempName = " ";
    var TempDescription = " ";
    var resofflimits = 0;
    
    if(!SessionCheck(this.router))
    {
      this.thisDialogRef.close('Cancel');
      return;
    }  
    let saveclick = document.getElementById('btnzonetempsaveclick');
        saveclick.className = 'clseditTempsavebutton mat-raised-button disablebtn';  
    (document.activeElement as HTMLTextAreaElement).blur();  
    if (this.flooreditTemplateForm.valid) {                
      if(zonetempFormValue.tempname.indexOf("-") == -1)
      {                      
        if(zonetempFormValue.tempname.length > 32)
        {
          generateAlertMessage(this.dialog, "Zone Template Name Max length 32 characters only");
          saveclick.className = 'clseditTempsavebutton mat-raised-button';
          return false;
        }
        else
        {
          TempName = zonetempFormValue.tempname.replace(/\s+/g, ' ').trim();
          TempDescription = " ";       
        }
      }
      else
      {        
        TempDescriName = zonetempFormValue.tempname.replace(/\s+/g, ' ').trim();
        TempDescriName = TempDescriName.split("-");
        TempName = TempDescriName[0];
        TempDescription = TempDescriName[1];
      }        
          
            let editzonetempdetails: updateTemplate = {
              siteId:this.SiteId,
              authKey: localStorage.getItem("Authkey"),
              templateId:parseInt(zonetempFormValue.tempID),
              templateName:TempName,     
              description:TempDescription,              
              templateCategoryId:1,              
            }
            
              this.technologyoverlayService.updateTemplateInfo(editzonetempdetails).pipe(takeUntil(this._onDestroy))
              .subscribe((apiresponse : any[])=>{                             
              if(apiresponse.toString() == "true")
              { 	
                generateAlertMessage(this.dialog, 'Zone Template edited successfully.');                   
                this.thisDialogRef.close("Delete");
              }    
              else if(apiresponse.toString() == "false")
              { 
                generateAlertMessage(this.dialog, 'Zone Template edited failed.');	                  
                this.thisDialogRef.close();
              }              
              else if(apiresponse["condition"] == "Authfalse")
              {    
                  this.thisDialogRef.close('close');              
                  AuthFailedMessage(this.dialog,this.router);  
                  return;       
              } 
              else if(apiresponse["condition"] == "tempName")
              {                
                generateAlertMessage(this.dialog, "Zone Template name '" + TempName + "' already exists.");  
                saveclick.className = 'clseditTempsavebutton mat-raised-button'; 
                return; 
              }
              
            });
    }
    else
    {
      saveclick.className = 'clseditTempsavebutton mat-raised-button'; 
    }
  }
  catch(err)
  {
    throw new Error('edit-templates.component.ts' + ' - updateTemplateInfo() - ' + err.message);
  }
}

DrawMapCall(_this, Templates) {

  let imgwh = map_widthandheight(Templates.ImageWidth, Templates.ImageHeight);
  var imgwidth = imgwh.ImageWidth;
  var imgheight = imgwh.ImageHeight;

  // Polygons style
  var labelStyle = label_Polygon(0);
  var fillcolorStyle = fillcolor_style(fillcolorPolygon.Incomplete);
  var style = [fillcolorStyle, labelStyle];

  var devicelabelStyle = new Style({

    text: new Text({
      font: '10px Poppins, sans-serif',
      overflow: true,
      fill: new Fill({
        color: '#000'
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 5
      }),
      offsetX: 0,
      offsetY: 25.5
    })
  });

  var deviceStyle = fillcolor_style(fillcolorPolygon.Completed);

  var fillStyle = [deviceStyle, devicelabelStyle];

  var map = mapTemplate_creation(_this.Zoneimageurl + Templates.FloorPlanImage, imgwidth, imgheight, 'mapEditZone_'+Templates.TemplateId, 3);

  //////////Floor Devices Start////////////

  var arrdevicemarker = [];
  var arrdevicemarkernoPoly = [];
  var SpaceInfo = Templates.SpaceDetail;

  if (SpaceInfo != null) {
    /// Geo Feature Collection ///
    var geoFloorjsonObject = get_geojsonObject_floor(enumRequestFrom.floorplan_page);
    geoFloorjsonObject.type = "FeatureCollection";

    var arrgeoFloorjsonObject = geoFloorjsonObject.features; // empty Object
    geoFloorjsonObject.features.length = 0;

    /// marker array ///
    var arrmarker = [];
    if (SpaceInfo.length > 0) {
      var arrSpaceInfo = SpaceInfo;
      LoadTechnologySpaceSvg(map, arrSpaceInfo, imgheight, imgwidth, arrdevicemarker, geoFloorjsonObject, arrdevicemarkernoPoly, devicelabelStyle, fillStyle, _this.Map_image_path, Templates.TemplateId);
      _this.editimageheight = imgheight;
      _this.editimagewidth = imgwidth;
    }
    else if (_this.FloorImageURL == null) {
      document.getElementById("map").innerHTML = "<span style='margin-top: 15%; padding-left: 45%;display:block;font-size:15px;font-weight:bold;'> Map Not Found.</span>";
    }
  }

  //////////Floor Devices End////////////
}

}
